jQuery(function(){
    gsap.utils.toArray(".parallax").forEach((section, i) => {
        section.bg = section.querySelector(".bg");
        let sectionHeight = section.offsetHeight;
        // Do the parallax effect on each section
        if (i) {
            section.bg.style.backgroundPosition = `50% ${-sectionHeight / 2}px`;
            gsap.to(section.bg, {
                backgroundPosition: `50% ${sectionHeight / 2}px`,
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    scrub: true
                }
            });
        }

        // the first image should be positioned against the top. Use px on the animating part to work with GSAP. 
        else {
            section.bg.style.backgroundPosition = "50% 0px";

            gsap.to(section.bg, {
                backgroundPosition: `50% ${sectionHeight / 2}px`,
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    start: "top top",
                    end: "bottom top",
                    scrub: 0
                }
            });
        }
    });

    var interiorSlide = new Swiper('.sub1-interior-slide', {
        loop: true,
        autoplay: {
            delay: 5000,
        },
        slidesPerView: 2.5,
        spaceBetween: 14,
        scrollbar:{
            el: '.swiper-scrollbar',
            draggable: true,
            dragSize:197
        },
        breakpoints: {
            // when window width is >= 320px
            590: {
                scrollbar:{dragSize:80},
                slidesPerView: 1.2,
                spaceBetween: 8
            },
            // when window width is >= 480px
            768: {
                scrollbar:{dragSize:110},
                slidesPerView: 1.5,
                spaceBetween: 12
            },
            // when window width is >= 640px
            1280: {
                scrollbar:{dragSize:150},
                slidesPerView: 2.2,
                spaceBetween: 14,
            }
        }
    });

    var howToOrtho = new Swiper('.how-to-ortho', {
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        // navigation: {
        //     nextEl: '.ctrls2.btn-dn',
        //     prevEl: '.ctrls2.btn-up',
        // },
        autoplay: {
            delay: 5000,
        },
    });

    var cavitySlide = new Swiper('.cavity-slide', {
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        // navigation: {
        //     nextEl: '.ctrls2.btn-dn',
        //     prevEl: '.ctrls2.btn-up',
        // },
        autoplay: {
            delay: 5000,
        },
    });


    //gradient bg expanding
    let expandCircle = gsap.timeline({
        scrollTrigger: {
            trigger: ".point-space-area",
            start: "100px bottom",
            end: "bottom bottom",
            scrub: 0.8,
        }
    }).to('.expanding-circle', {
        scale: 1.1
    }, 0);


    let opaBg = gsap.timeline({
        scrollTrigger: {
            trigger: ".reveal-point",
            start: "-100px top",
            end: "bottom bottom",
            pin: ".grdient-bg"
        }
    }).fromTo('.grdient-bg', {opacity:0},{
        opacity: .9
    }, 0);




    //waypoint 클래스 추가
    let animElem = document.querySelectorAll('.anim');
    animElem.forEach(elem => {
        gsap.timeline({
            scrollTrigger:{
                trigger:elem,
                start:'top 70%',
                toggleActions:'play none none none',
                onEnter:()=>elem.classList.add('on')
            }
        })
    });

    var footSlider = new Swiper('.foot-slider', {
        speed: 600,
        slidesPerView: 1.8,
        spaceBetween: 60,
        autoplay: {
            delay: 4000,
        },
        freeMode: true,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
            dragSize: 160
        },
        breakpoints: {
            // when window width is >= 320px
            590: {
                slidesPerView: 1.2,
                spaceBetween: 20
            },
            // when window width is >= 480px
            768: {
                slidesPerView: 1.25,
                spaceBetween: 30
            },
            // when window width is >= 640px
            1280: {
                slidesPerView: 1.5,
                spaceBetween: 40
            }
        }
    });

    const getSecondElement = document.querySelectorAll(".link-to-seconds li");

    if(getSecondElement){
        const sub1Interview = new Vimeo.Player('sub1-interview', {
            id: 506972760
        });

        getSecondElement.forEach((element) => {
            element.addEventListener("click", function(event){
                let second = this.dataset.vidtime;
                sub1Interview.setCurrentTime(second);
            })
        });
    }

});